module.exports = __webpack_public_path__ + "img/20190628160912747.5332d2e3.png";